import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kgToTons',
  standalone: true
})
export class KgToTonsPipe implements PipeTransform {
  transform(kg: number | null, decimals: number = 3): string {
    if (kg === null || kg === undefined) return '-';
    const tons = kg / 1000;


    let formatted = tons.toFixed(decimals);

 
    formatted = formatted.replace(/\.?0+$/, '');

    formatted = formatted.replace('.', ',');

    return formatted;
  }
}
